import { downloadFile, formatCSV } from "../../helpers/downloadData";

export const DownloadDataButton = ({ data }) => (
  <button
    title="Download data as a .CSV file"
   class="btn"
    onClick={() =>
      downloadFile({
        data: formatCSV(data),
        type: "text/csv",
        extension: ".csv",
      })
    }
  >
    Download
  </button>
);
